import React, { useRef } from 'react'

import ThanxAISuggestionChip from 'components/AI/ThanxAISuggestionChip'
import { buildTranslate } from 'locales'
import { generateId } from 'utilities/uniqueId'
import './ThanxAISuggestionList.scss'

const t = buildTranslate('segments.ai_prompt')

export interface ThanxAISuggestionListProps {
  suggestions: string[]
  onSuggestionClick: (suggestion: string) => void
}

const ThanxAISuggestionList = ({
  suggestions,
  onSuggestionClick,
}: ThanxAISuggestionListProps) => {
  const suggestionHelpIdRef = useRef(
    // This is required to make snapshot tests deterministic
    process.env.NODE_ENV === 'test'
      ? 'suggestion-help-test'
      : `suggestion-help-${generateId()}`
  )
  const suggestionHelpId = suggestionHelpIdRef.current

  if (suggestions.length === 0) {
    return null
  }

  return (
    <>
      <p id={suggestionHelpId} className="sr-only">
        {t('suggestions_help_text')}
      </p>
      <ul
        className="thanx-ai-prompt__suggestions"
        aria-labelledby={suggestionHelpId}
      >
        {suggestions.map((suggestion, index) => (
          <ThanxAISuggestionChip
            key={index}
            suggestion={suggestion}
            onClick={onSuggestionClick}
          />
        ))}
      </ul>
    </>
  )
}

export default ThanxAISuggestionList
